const Torus = () => (
    <svg
        width='38'
        height='38'
        viewBox='0 0 38 38'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        id='torus'
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M37.012 18.5432C37.012 28.7844 28.7266 37.0865 18.506 37.0865C8.28543 37.0865 0 28.7844 0 18.5432C0 8.30209 8.28543 0 18.506 0C28.7266 0 37.012 8.30209 37.012 18.5432ZM20.658 10.3289H10.329V16.3542H14.6327V28.4047H20.6579V16.3542H20.658V10.3289ZM25.392 16.3542C27.0558 16.3542 28.4046 15.0055 28.4046 13.3416C28.4046 11.6778 27.0558 10.329 25.392 10.329C23.7282 10.329 22.3794 11.6778 22.3794 13.3416C22.3794 15.0055 23.7282 16.3542 25.392 16.3542Z'
            fill='white'
        />
    </svg>
);

export default Torus;
